/**
 * StatChip — icon + value + label tile used in the 2×2 stat grid on State 4.
 */

import React from 'react';

interface StatChipProps {
  icon: React.ReactNode;
  iconBg: string;
  value: string | number;
  label: string;
}

export const StatChip: React.FC<StatChipProps> = ({ icon, iconBg, value, label }) => {
  return (
    <div
      className="flex items-center gap-3 p-4 rounded-2xl bg-white transition-transform duration-200 hover:-translate-y-0.5"
      style={{ border: '1.5px solid #e8e8ee' }}
    >
      <div
        className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 text-lg"
        style={{ background: iconBg }}
      >
        {icon}
      </div>
      <div>
        <p className="font-montserrat font-bold text-xl text-neutral-800 leading-tight">
          {value}
        </p>
        <p className="font-open-sans text-xs text-neutral-500">{label}</p>
      </div>
    </div>
  );
};
